import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock, User, Eye, EyeOff } from 'lucide-react';

const AdminLogin = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    // Simulate API call
    await new Promise(resolve => setTimeout(resolve, 800));

    // Simple hardcoded credentials for demo
    // In production, this should be handled by a backend
    if (username === 'Admin01' && password === 'eihxd7cc88rF20M!') {
      localStorage.setItem('seltz_admin_auth', 'true');
      localStorage.setItem('seltz_admin_user', username);
      navigate('/admin');
    } else {
      setError('Username sau parolă incorecte');
    }

    setLoading(false);
  };

  return (
    <main className="min-h-screen bg-[#0a0a0a] flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="text-center mb-10">
          <img 
            src="/assets/images/logo.png" 
            alt="SELTZ" 
            className="h-16 w-auto object-contain invert brightness-0 mx-auto mb-6"
          />
          <h1 
            className="text-white font-black italic text-2xl"
            style={{ fontFamily: 'Nunito, sans-serif' }}
          >
            admin login
          </h1>
          <p className="text-white/50 text-sm mt-2" style={{ fontFamily: 'Nunito, sans-serif' }}>
            Acces restricționat
          </p>
        </div>

        {/* Login Form */}
        <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-8">
          <form onSubmit={handleSubmit} className="flex flex-col gap-5">
            {/* Username */}
            <div className="flex flex-col gap-2">
              <label 
                className="text-white/70 text-xs font-bold uppercase tracking-wider"
                style={{ fontFamily: 'Nunito, sans-serif' }}
              >
                Username
              </label>
              <div className="relative">
                <User className="absolute left-4 top-1/2 -translate-y-1/2 text-white/30" size={18} />
                <input
                  type="text"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  placeholder="Admin01"
                  className="w-full bg-white/5 border border-white/10 rounded-xl pl-12 pr-4 py-3.5 text-white placeholder-white/30 text-sm font-semibold focus:outline-none focus:border-white/30 transition-colors"
                  style={{ fontFamily: 'Nunito, sans-serif' }}
                  required
                />
              </div>
            </div>

            {/* Password */}
            <div className="flex flex-col gap-2">
              <label 
                className="text-white/70 text-xs font-bold uppercase tracking-wider"
                style={{ fontFamily: 'Nunito, sans-serif' }}
              >
                Parolă
              </label>
              <div className="relative">
                <Lock className="absolute left-4 top-1/2 -translate-y-1/2 text-white/30" size={18} />
                <input
                  type={showPassword ? 'text' : 'password'}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="••••••••"
                  className="w-full bg-white/5 border border-white/10 rounded-xl pl-12 pr-12 py-3.5 text-white placeholder-white/30 text-sm font-semibold focus:outline-none focus:border-white/30 transition-colors"
                  style={{ fontFamily: 'Nunito, sans-serif' }}
                  required
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute right-4 top-1/2 -translate-y-1/2 text-white/30 hover:text-white/50 transition-colors"
                >
                  {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                </button>
              </div>
            </div>

            {/* Error Message */}
            {error && (
              <div className="bg-red-500/10 border border-red-500/20 rounded-lg px-4 py-3">
                <p className="text-red-400 text-sm font-bold text-center" style={{ fontFamily: 'Nunito, sans-serif' }}>
                  {error}
                </p>
              </div>
            )}

            {/* Submit Button */}
            <button
              type="submit"
              disabled={loading}
              className="w-full bg-white text-[#0a0a0a] font-black italic text-sm py-4 rounded-xl hover:bg-white/90 transition-all disabled:opacity-50 disabled:cursor-not-allowed mt-2"
              style={{ fontFamily: 'Nunito, sans-serif' }}
            >
              {loading ? 'Se încarcă...' : 'Intră în cont'}
            </button>
          </form>

          {/* Back to site */}
          <div className="mt-6 text-center">
            <a 
              href="/"
              className="text-white/40 hover:text-white/60 text-sm font-semibold transition-colors"
              style={{ fontFamily: 'Nunito, sans-serif' }}
            >
              ← înapoi la site
            </a>
          </div>
        </div>

        {/* Demo credentials hint */}
        <div className="mt-8 text-center">
          <p className="text-white/30 text-xs" style={{ fontFamily: 'Nunito, sans-serif' }}>
            Demo: username: <span className="text-white/50">Admin01</span> / parolă: <span className="text-white/50">eihxd7cc88rF20M!</span>
          </p>
        </div>
      </div>
    </main>
  );
};

export default AdminLogin;
